exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-textarea[data-v-05a376b1] {\n  position: relative;\n}\n.my-textarea .my-textarea-label[data-v-05a376b1] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  line-height: 3rem;\n  margin-left: 0.75rem;\n  color: grey;\n  transition: all 0.2s;\n}\n.my-textarea.is-focus textarea[data-v-05a376b1] {\n  padding-top: 1.3rem;\n}\n.my-textarea.is-focus .my-textarea-label[data-v-05a376b1] {\n  top: 0.5rem;\n  font-size: 0.75rem;\n  border-radius: 5px;\n  height: auto;\n  line-height: 1;\n}", ""]);

// exports
